var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"icon d-icon",class:[_vm.size, _vm.position, 'icon-'+_vm.icon],domProps:{"innerHTML":_vm._s(_vm.svg)}})
}
var staticRenderFns = []

export { render, staticRenderFns }